import React, { useRef } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { motion, AnimatePresence } from "framer-motion"
import Measure from 'react-measure'

import { Tooltip, Animation } from 'components'
import ListTab from './ListTab'
import { TaskTab } from './FeatureTabs'

import * as actionCreators from 'store/actions'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    /* position: relative; */
`

const CardContainer = styled.div`
    max-width: 80vw;
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    align-items: center;
    justify-content: ${props => props.minimize ? 'flex-start' : 'center'};

    flex-wrap: ${props => props.minimize ? 'nowrap' : 'wrap'};
    align-content: flex-start;
`

const Card = styled.img`
    /* src:'https://ecgc2.csb.app/images/c.jpg', */
    object-fit: cover; 
    width: ${props => props.minimize ? '6rem' : '10rem'};
    height: ${props => props.minimize ? '6rem' : '10rem'};
    border-radius: 10px;
    cursor: pointer;
    margin-right: 1rem;
    margin-bottom: 1rem;
`

const FeatureList = props => {
    const [tab, setTab] = React.useState(null)
    const [boundingRect, setBounds] = React.useState(null)
    const ref = useRef(null);

    const tabs = {
        'List/Kanban': 'https://ecgc2.csb.app/images/c.jpg',
        Focus: 'https://ecgc2.csb.app/images/c.jpg',
        Collaborate: 'https://ecgc2.csb.app/images/c.jpg',
        Integrations: 'https://ecgc2.csb.app/images/c.jpg'
    }

    const selectTab = value => {
        setTab(value)
        setTimeout(() => {
            value && window.scrollTo({ behavior: 'smooth', top: (ref.current.offsetTop + (16*2)) })
            !value && window.scrollTo({ behavior: 'smooth', top: 0 })
        }, 100)
        
    }

    // Selectors
    const selectors = <CardContainer minimize={tab} >
                        {Object.entries(tabs).map((t => (
                            <Tooltip title={t[0]} arrow>
                                <Card selected={tab === t[0]} 
                                    src={t[1]} onClick={() => selectTab(tab === t[0] ? null : t[0])}/>
                                {/* <Card minimize={tab} selected={tab === t[0]} 
                                    src={t[1]} onClick={() => selectTab(tab === t[0] ? null : t[0])}/> */}
                            </Tooltip>
                        )))}
                    </CardContainer>

    // Content
    let content = tab === 'List/Kanban' ? <TaskTab/>
                : tab === 'Focus' ? <TaskTab/>
                : tab === 'Collaborate' ? <TaskTab/>
                : tab === 'Integrations' ? <TaskTab/>
                : null

    return (
        <Container ref={ref}>
            {selectors}
            
            <Measure bounds onResize={contentRect => setBounds(contentRect.bounds)} >
                {({ measureRef }) => (
                    <div ref={measureRef} style={{width: '100%'}}>
                        <AnimatePresence key={tab}>
                            <motion.div size='100%' position="relative" background='transparent' style={{display: 'flex', flexDirection:'column', alignItems:'center'}}
                                initial="collapsed"
                                animate="open"
                                exit="collapsed"
                                variants={{
                                    open: { height: 'auto' },
                                    collapsed: { height: boundingRect ? boundingRect.height : 0 }
                                }}
                                transition={{ duration: 1, ease: [0.04, 0.62, 0.23, 0.98] }}>
                                    {content}
                            </motion.div>
                        </AnimatePresence>
                    </div>
                )}
            </Measure>
        </Container>
    )
}

export default FeatureList